import { DataForm } from '@tencent/data-schema/lib/vue-ui/DataForm';
import { propPanelMixin, mapCompProp } from "../../../../lib/helpers";
import ExprInput from "../../../../lib/comps/ExprInput";
import TabPaneMeta from '../TabPane/meta';
import { calmComputed } from "../../../../lib/utils";
import { isArrayShallowEqual } from "../../../../lib/utils/array";
import { addTabPane } from './actions';
const tabPanePropsSchema = TabPaneMeta.propsSchema;
const __script_base__ = {
  name: 'TabsPropPanel',
  components: {
    DataForm,
    ExprInput
  },
  mixins: [propPanelMixin],
  computed: {
    defaultTabIndex: mapCompProp('cur'),
    titleCss: mapCompProp('titleCss'),
    allTabTitles: calmComputed(function () {
      var _this$getCompInstance;
      return ((_this$getCompInstance = this.getCompInstance().allTabs) === null || _this$getCompInstance === void 0 ? void 0 : _this$getCompInstance.map(tabPane => tabPane.title)) || [];
    }, isArrayShallowEqual),
    actualCurrent: calmComputed(function () {
      var _this$getCompInstance2;
      return (_this$getCompInstance2 = this.getCompInstance()) === null || _this$getCompInstance2 === void 0 ? void 0 : _this$getCompInstance2.current;
    }),
    tabPanePropsSchema: () => tabPanePropsSchema,
    dataSchemaContextOptions() {
      return this.uc.getDataFormContextOptions({});
    },
    currentTabPaneProps() {
      const {
        children
      } = this.comp;
      if (!children) return null;
      const layout = children[Math.min(this.actualCurrent, children.length - 1)];
      if (!layout) return null;
      if (!layout.props) this.$set('layout', 'props', {});
      return layout.props;
    }
  },
  methods: {
    gotoTab(index) {
      this.getCompInstance().current = index;
    },
    async addTab() {
      await this.designer.modifyActiveComp(addTabPane);
      this.gotoTab(this.getCompInstance().allTabs.length - 1);
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", [_c("p", [_vm._v("\n    当前正在编辑：\n\n    "), _vm._l(_vm.allTabTitles, function (tab, index) {
    return _c("button", {
      key: index,
      staticClass: "uc-button",
      class: {
        isPrimary: index === _vm.actualCurrent
      },
      staticStyle: {
        "min-width": "24px"
      },
      on: {
        click: function ($event) {
          return _vm.gotoTab(index);
        },
        dblclick: function ($event) {
          _vm.defaultTabIndex = index;
        }
      }
    }, [_vm._v("\n      " + _vm._s(index + 1) + "\n    ")]);
  }), _vm._v(" "), _c("button", {
    staticClass: "uc-button",
    on: {
      click: function ($event) {
        return _vm.addTab();
      }
    }
  }, [_c("i", {
    staticClass: "fa fa-plus"
  }), _vm._v(" 新增\n    ")])], 2), _vm._v(" "), _vm.currentTabPaneProps ? _c("DataForm", {
    key: _vm.actualCurrent,
    staticClass: "uc-dataForm uc-dataForm-vertical",
    attrs: {
      schema: _vm.tabPanePropsSchema,
      value: _vm.currentTabPaneProps,
      "context-options": _vm.dataSchemaContextOptions
    },
    on: {
      change: function ($event) {
        return _vm.uc.notifyPageletsChange();
      }
    }
  }) : _vm._e(), _vm._v(" "), _c("div", {
    staticStyle: {
      height: "0",
      margin: "1em 0",
      "border-top": "1px solid #ccc"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c("p", [_vm._v("\n    默认页卡：\n    "), _c("select", {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: _vm.defaultTabIndex,
      expression: "defaultTabIndex",
      modifiers: {
        number: true
      }
    }],
    staticClass: "uc-inputbox",
    on: {
      change: function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return _vm._n(val);
        });
        _vm.defaultTabIndex = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(_vm.allTabTitles, function (title, index) {
    return _c("option", {
      key: index,
      domProps: {
        value: index
      }
    }, [_vm._v("\n        " + _vm._s(title) + "\n      ")]);
  }), 0)]), _vm._v(" "), _c("p", [_vm._v("\n    自定义页卡标题栏样式：\n  ")]), _vm._v(" "), _c("div", [_c("expr-input", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      "multiple-line": "",
      type: "interopable-string"
    },
    model: {
      value: _vm.titleCss,
      callback: function ($$v) {
        _vm.titleCss = $$v;
      },
      expression: "titleCss"
    }
  })], 1)], 1);
};
var staticRenderFns = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("ul", [_c("li", [_vm._v("鼠标放在预览区 Tabs 卡区域，可添加/删除/改名")]), _vm._v(" "), _c("li", [_vm._v("可拖拽调整Tab卡顺序")]), _vm._v(" "), _c("li", [_vm._v("双击某个页卡，可将其设置为默认页卡")])]);
}];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/components/Tabs/PropPanel.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);